import Select from "react-select";

// SCSS
import styles from "./index.module.scss";

const SelectInput = ({
  label,
  value,
  submitStatus,
  parentClass,
  options,
  required,
  disabled,
  onChange,
  onInputChange,
  isSearchable,
  focus,
  blur,
  error,
  touched,
  usedFor = "",
  menuPortal,
}) => {
  let customCss = {};
  if (usedFor === "Filter") {
    customCss = {
      container: (styles) => ({ ...styles, maxHeight: "33px" }),
      control: (styles, state) => ({
        ...styles,
        borderTop: "none !important",
        borderRight: "none !important",
        borderLeft: "none !important",
        borderRadius: 0,
        background: "transparent",
        maxHeight: "33px",
        boxShadow: "none",
      }),
      valueContainer: (styles) => ({
        ...styles,
        paddingLeft: 0,
        maxHeight: "33px",
        color: "#212721",
      }),
      input: (styles) => ({ ...styles, maxHeight: "24px" }),
      placeholder: (styles) => ({ ...styles, maxHeight: "24px" }),
      singleValue: (styles) => ({ ...styles, maxHeight: "33px" }),
      menu: (styles) => ({
        ...styles,
        backgroundColor: "#fff",
        borderRadius: "4px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        zIndex: 9999,
      }),
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? "#CB998D" : state.isFocused ? "#F7F0EE" : "#fff",
        color: state.isSelected ? "#fff" : "#212721",
        padding: "8px 12px",
        cursor: "pointer",
        fontSize: "16px",
        lineHeight: "1.4",
        "&:hover": {
          backgroundColor: state.isSelected ? "#b88a7e" : "#F7F0EE",
        },
        "&:last-child": {
          borderBottom: "none",
        },
      }),
      menuList: (styles) => ({
        ...styles,
        padding: "5px 0",
        maxHeight: "200px",
      }),
    };
  } else {
    customCss = {
      control: (styles, state) => ({
        ...styles,
        borderTop: "none",
        borderRight: "none",
        borderLeft: "none",
        borderRadius: 0,
        background: "transparent",
        boxShadow: "none",
        fontSize: 20,
        height: 44,
      }),
      valueContainer: (styles) => ({
        ...styles,
        paddingLeft: 0,
        height: 44,
        color: "#212721",
      }),
      menu: (styles) => ({
        ...styles,
        backgroundColor: "#fff",
        border: "1px solid #dee2e6",
        borderRadius: "4px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        zIndex: 9999,
      }),
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? "#CB998D" : state.isFocused ? "#F7F0EE" : "#fff",
        color: state.isSelected ? "#fff" : "#212721",
        padding: "10px 15px",
        cursor: "pointer",
        fontSize: "16px",
        lineHeight: "1.5",
        fontWeight: "400",
        "&:hover": {
          backgroundColor: state.isSelected ? "#b88a7e" : "rgba(192, 131, 116, 0.2)",
          color: state.isSelected ? "#fff" : "#212721",
        },
        "&:last-child": {
          borderBottom: "none",
        },
      }),
      menuList: (styles) => ({
        ...styles,
        padding: "5px 0",
        maxHeight: "300px",
      }),
    };
  }

  return (
    <div
      className={`form-group bmd-form-group ${
        value || value === 0 ? "is-filled" : ""
      } ${parentClass ? parentClass : ""} ${
        submitStatus && required && !value ? styles.errorInput : ""
      }`}
    >
      <label className={`bmd-label-floating ${styles.selectLabel}`}>
        {label}
      </label>
      <Select
        placeholder=""
        menuPortalTarget={menuPortal && menuPortal}
        value={options?.find((optionsObj) => optionsObj.id === value) ?? ""}
        isDisabled={disabled}
        blur={blur}
        onInputChange={(e) => {
          if (onInputChange) {
            onInputChange(e);
          }
        }}
        getOptionLabel={(option) => {
          if (!value && options.length === 0) {
            return "";
          } else {
            return option.length !== 0
              ? option.first_name
                ? `${option.first_name} ${option.last_name}`
                : option.name
                ? option.name
                : option.title
                ? option.title
                : option.zone && option.country_name
                ? option.zone + " (" + option.country_name + ")"
                : ""
              : "";
          }
        }}
        getOptionValue={(option) => `${option.id}`}
        onChange={(data) => onChange(data)}
        options={options}
        styles={customCss}
        components={{
          IndicatorSeparator: () => null,
        }}
        isSearchable={isSearchable}
        maxMenuHeight={usedFor === "Filter" ? 200 : 300}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: "#CB998D",
            primary25: "rgba(203,153,141,.15)",
            primary50: "rgba(203,153,141,.25)",
            primary75: "rgba(203,153,141,.75)",
            neutral0: "#fff",
            neutral5: "#F7F0EE",
            neutral10: "#e9ecef",
            neutral20: "#dee2e6",
            neutral30: "#adb5bd",
            neutral40: "#6c757d",
            neutral50: "#495057",
            neutral60: "#212721",
            neutral70: "#1a1d1a",
            neutral80: "#141614",
            neutral90: "#0e0f0e",
          },
        })}
      />
      {error && touched && <p className="invalid-feedback d-block">{error}</p>}
    </div>
  );
};

export default SelectInput;
